function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M2 11l9-9 9 9",
  stroke: "#039BE8",
  strokeWidth: 3,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var SvgArrowUpSmall = function SvgArrowUpSmall(props) {
  return React.createElement("svg", _extends({
    width: 22,
    height: 13,
    viewBox: "0 0 22 13",
    fill: "none"
  }, props), _ref);
};

export default "data:image/svg+xml,%3Csvg width='22' height='13' viewBox='0 0 22 13' fill='none' xmlns='http://www.w3.org/2000/svg'%3E %3Cpath d='M2 11L11 2L20 11' stroke='%23039BE8' stroke-width='3' stroke-linecap='round' stroke-linejoin='round' /%3E %3C/svg%3E";
export { SvgArrowUpSmall as ReactComponent };